<!--
 * @FileDescription: 退款成功页面-Mobile
 * @Author: 陈文景
 * @Date: 2022-11-07 09:42:30
 * @LastEditors: 最后更新作者
 * @LastEditTime: 最后更新时间
-->
<template>
  <div>
    <div class="tips">
      <div class="content">
        <span class="icon">
          <i class="el-icon-success" />
        </span>
        <h3 class="title">{{ $t('Order.Refund.Success.Mobile.Index.SubmittedSuccessfully') }}</h3>
        <div class="subheading">{{ $t('Order.Refund.Success.Mobile.Index.WaitingForReview') }}</div>
      </div>
    </div>

    <div class="good">
      <GoodItem v-for="good in goods" :key="good.skuCode" :data="good" />
    </div>

    <!-- <div class="order-info">
      <h3>Rufund Information</h3>
      <div class="details">
        <p class="item">
          <span class="label">Order ID</span>
          <span class="value">-</span>
        </p>
        <p class="item">
          <span class="label">Tracking code</span>
          <span class="value">-</span>
        </p>
        <p class="item">
          <span class="label">Payment Time</span>
          <span class="value">-</span>
        </p>
      </div>
    </div> -->

    <!-- <div class="payment-info">
      <h3>Refunded Amount</h3>
      <div class="details">
        <p class="item">
          <span class="label">Item Subtotal</span>
          <span class="value">-</span>
        </p>
        <p class="item">
          <span class="label">Shipping Subtotal</span>
          <span class="value">-</span>
        </p>
        <p class="item">
          <span class="label">Promotion</span>
          <span class="value">-</span>
        </p>
        <p class="item">
          <span class="label">Total</span>
          <span class="value strong">-</span>
        </p>
      </div>
    </div> -->

    <!-- <div class="address-info">
      <i class="el-icon-location-outline" />
      <div class="info">
        <p>-</p>
        <p>-</p>
        <p>-</p>
      </div>
    </div> -->

    <div class="refunded-button">
      <VanButton :block="true" color="#99C41C" class="van-button" @click="goToAllOrderList">{{ $t('Order.Refund.Success.Mobile.Index.AllOrders') }}</VanButton>
    </div>
  </div>
</template>

<script>
import API from '@/api'

import VanButton from 'vant/lib/button'
import 'vant/lib/button/style'

import { formatTimeStamp } from '@/util/moment'

import GoodItem from './components/GoodItem.vue'

export default {
  components: {
    GoodItem,
    VanButton
  },
  data() {
    return {
      formatTimeStamp,

      loading: false,

      goods: [],

      details: {} // 详情
    }
  },
  computed: {
    amountTips() {
      return (value) => value || 0
    },
    defaultTips() {
      return (value) => value || '-'
    }
  },
  created() {
    this.getAfterSalesOrderDetails()
  },
  methods: {
    /**
     * API 获取售后订单详情
     */
    async getAfterSalesOrderDetails() {
      try {
        this.loading = true
        let { data } = await API.getAfterSalesOrderDetails(this.$route.query.returnsId)
        data.packItems = this.reformData(data.packItems || [])
        this.goods = this.getGoodsList(data.packItems || [])
        this.details = data
        this.loading = false
      } catch (error) {
        this.loading = false
      }
    },

    /**
     * 获取申请退款的商品列表
     *
     * @param {Array} data 原数据
     * @returns {Array} 商品列表
     */
    getGoodsList(data) {
      if (data.length) {
        let goods = []
        data.forEach((outside) => {
          if (outside && outside.items && outside.items.length) {
            outside.items.forEach((item) => {
              goods.push(item)
            })
          }
        })
        return goods
      } else {
        return data
      }
    },

    /**
     * 改造未发货列表数据
     *
     * @param {Array} data 原数据
     * @returns {Array} 改造后的数据
     */
    reformData(data) {
      if (data.length) {
        data.forEach((outside) => {
          if (outside && outside.items && outside.items.length) {
            outside.items = outside.items.map((item) => ({
              ...item,
              options:
                JSON.parse(item.options) &&
                JSON.parse(item.options)
                  .map((option) => JSON.parse(option).value)
                  .join('、')
            }))
          }
        })
      }
      return data
    },

    /**
     * 跳转到所有订单页面
     */
    goToAllOrderList() {
      this.$router.push('/order/list')
    }
  }
}
</script>

<style lang="scss" scoped>
.tips,
.good,
.order-info,
.payment-info,
.address-info {
  background-color: #fff;
}

.tips {
  position: relative;
  margin: 10px 0;
  .content {
    height: 100%;
    text-align: center;
    padding-top: 62px;
    padding-bottom: 28px;
    .icon {
      color: #99c41c;
      font-size: 62px;
    }
    .title {
      color: #000000;
      font-size: 18px;
      margin: 12px 0;
    }
    .subheading {
      font-size: 14px;
    }
    .el-button {
      width: 216px;
      height: 45px;
      font-size: 16px;
      font-weight: 400;
    }
  }
}

.good {
  padding: 18px;
  margin-bottom: 85px;
}

.order-info,
.payment-info {
  h3 {
    color: #10141d;
    font-size: 16px;
    font-weight: 500;
  }
  .details {
    .item {
      display: flex;
      padding: 15px 0;
      align-items: center;
      border-bottom: 1px solid #dedede;
      justify-content: space-between;
      .label {
        color: #000;
      }
      .value {
        color: #7b7b7b;
        &.strong {
          color: #10141d;
          font-size: 16px;
          font-weight: 600;
        }
        &.danger {
          color: #f56c6c;
        }
      }
      &.border {
        border: 0;
      }
    }
  }
}

.order-info,
.payment-info,
.address-info {
  padding: 15px 20px;
}

.order-info {
  margin: 10px 0;
}

.address-info {
  position: relative;
  display: flex;
  margin: 10px 0;
  &::before {
    position: absolute;
    content: '';
    right: 0;
    bottom: 0;
    left: 0;
    height: 2px;
    background: repeating-linear-gradient(-45deg, #ff6c6c 0, #ff6c6c 20%, transparent 0, transparent 25%, #1989fa 0, #1989fa 45%, transparent 0, transparent 50%);
    background: -webkit-repeating-linear-gradient(135deg, #ff6c6c 0, #ff6c6c 20%, transparent 0, transparent 25%, #1989fa 0, #1989fa 45%, transparent 0, transparent 50%);
    background-size: 80px;
  }
  i {
    font-size: 16px;
    margin-top: 3px;
  }
  .info {
    margin-left: 5px;
  }
}

.refunded-button {
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  padding: 8px 15px;
  background-color: #fff;
  box-shadow: 0px 0px 8px 0 rgba(0, 0, 0, 0.12);
  z-index: 9527;
  .van-button {
    height: 44px;
    border-radius: 8px;
  }
}
</style>
